module.exports = __webpack_public_path__ + "img/star-map-step_2.5cf081b.webp";